<div class="header uppercase">
  <div 
    *ngFor="let tab of tabOptions, let i = index"
    (click)="onTabClick(i)"
    class="header_item"
    [ngClass]="{ 'header_item--underline': (globalsService.currentTab$ | async) === i }">
      {{ tab }}
  </div>
</div>
